import { useCallback, useEffect } from 'react';
import socketService from '../services/socketService';

export const useQuestionnaireSocket = ({
    organizationId,
    onTeamResponseUpdate,
    onCommentAdd,
    onReactionAdd,
    onResponseLock
}) => {
    const handleSocketUpdate = useCallback((data) => {
        switch (data.type) {
            case 'team_response_updated':
                onTeamResponseUpdate?.(data.questionId, data.response);
                break;
            
            case 'question_comment_added':
                onCommentAdd?.(data.questionId, data.comment);
                break;
            
            case 'question_reaction_added':
                onReactionAdd?.(data.questionId, data.responseId, data.reaction);
                break;
            
            case 'response_locked':
                onResponseLock?.(data.questionId, data.userId);
                break;
        }
    }, [onTeamResponseUpdate, onCommentAdd, onReactionAdd, onResponseLock]);

    useEffect(() => {
        if (!organizationId) return;

        const connect = async () => {
            try {
                await socketService.connect();
                await socketService.joinOrganization(organizationId);

                // Use existing socket event handling method
                socketService.onResponseUpdate(handleSocketUpdate);
            } catch (error) {
                console.error('Error connecting to socket:', error);
            }
        };

        connect();

        return () => {
            socketService.disconnect();
        };
    }, [organizationId, handleSocketUpdate]);

    return {
        emitTeamResponse: (questionId, response) => {
            socketService.emit('questionnaire_update', {
                type: 'team_response_updated',
                questionId,
                response,
                organizationId
            });
        },
        emitComment: (questionId, comment) => {
            socketService.emit('questionnaire_update', {
                type: 'question_comment_added',
                questionId,
                comment,
                organizationId
            });
        },
        emitReaction: (questionId, responseId, reaction) => {
            socketService.emit('questionnaire_update', {
                type: 'question_reaction_added',
                questionId,
                responseId,
                reaction,
                organizationId
            });
        },
        emitLock: (questionId, userId) => {
            socketService.emit('questionnaire_update', {
                type: 'response_locked',
                questionId,
                userId,
                organizationId
            });
        }
    };
};